export const environment = {
  production: false,
  graphql: 'https://stage-api.anylytics.ai/graphql',
  graphqlWs: 'wss://stage-api.anylytics.ai/graphql',
  api: 'https://stage-api.anylytics.ai',
  firebaseConfig: {
    apiKey: 'AIzaSyAxOH33ZW2RbWDm8dnL635NsdLwffzQvCo',
    authDomain: 'the-insights-factory.firebaseapp.com',
    projectId: 'the-insights-factory',
    storageBucket: 'the-insights-factory.appspot.com',
    messagingSenderId: '7048446009',
    appId: '1:7048446009:web:21394f08d83d82d0c2cde8',
    measurementId: 'G-2DJL3FB129',
  },
  stripePublishableKey: 'pk_test_51Q3uboCIino6iuqJ5L9s8fUuvzL7fWH62iZ5zmgBWRsYO6fdifhlkBMIM6546hydf0fKjfR5iEZuJ8l0WgnAfiNS00KIgldAQ8',
  defaultModelId: '66a5287e282b39f96ba6b23c', // GPT-5
  posthog_key:'phc_F3lXIz0V52FAlasEoJkDlqVuY58QkXVfjRWCzMr767T',
  posthog_host:'https://us.i.posthog.com', 
  sentry_dsn: 'https://6ebc4e04d11f18189d06bfca93388f94@o4509315313172480.ingest.us.sentry.io/4509315618045952',
};
